import React, {Component,PropTypes} from 'react';
import intl from 'react-intl';

import TechInfo from './TechInfo';
import Input    from '../Input';


import './footer.scss';

class Footer extends Component {

    static propTypes = {
        currentLocale: PropTypes.string,
        onLocaleChange: PropTypes.func
    };

    render() {

        return (
            <footer>
                <TechInfo />
                <div className="lang-selector">
                    <Input type="select" onChange={this.props.onLocaleChange} value={this.props.currentLocale} browserDefault>
                        <option value="en">English</option>
                        <option value="nl">Nederlands</option>
                        <option value="de">Deutsch</option>
                        <option value="fr">Français</option>
                    </Input>
                </div>
            </footer>
        );

    }
}
export default Footer;